import InProcessBuild from "../../../components/InProcessBuild";
import Config from "./Config";
import HistoryDetect from "./HistoryDetect";
import LicensePlate from "./LisencePlate";
import StatisticAI from "./Statistic";


export const LisencePlate = [
    {
        tabIndex: 0,
        tabName: 'Xem lại sự kiện',
        component: <LicensePlate />
    },
    {
        tabIndex: 1,
        tabName: 'Cấu hình',
        component: <Config />
    },
    {
        tabIndex: 3,
        tabName: 'Lịch sử cảnh báo',
        component: <HistoryDetect/>
    },
    {
        tabIndex: 4,
        tabName: 'Thiết lập cảnh báo ',
        component: <InProcessBuild />
    },
    {
        tabIndex: 5,
        tabName: 'Thống kê xuất báo cáo',
        component: <StatisticAI />
    },
]
